import api from '../../../api/axios';
import { Discipline } from './enum';
import { ContactPayload, CreateUser, LoginData, Report } from './type';


export const getCourses = async (date: string) => {
  const { data } = await api.get(`/programme/${date}`);
  return data;
};

export const getPronos = async (date: string, reunion: number, course: number) => {
  const { data } = await api.get(
    `/programme/${date}/${reunion}/${course}/prono`
  );
  return data;
};

export const getDetail = async (date?: string, reunion?: number, course?: number) => {
  if (!date || !reunion || !course) return null;
  const { data } = await api.get(
    `/programme/${date}/${reunion}/${course}/detail`
  );
  return data;
};

export const getStats = async (
  hippodrome: string,
  price: number,
  discipline: Discipline,
  heureDepart: number
) => {
  const { data } = await api.get(`/stats`, {
    params: {
      hippodrome,
      price,
      discipline,
      heureDepart,
    },
  });

  return data;
};

export const getProducts = async (token?: string) => {
  const { data } = await api.get(`/products`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const loginUser = async (data: LoginData) => {
  const { data: response } = await api.post(`/login`, data);
  return response;
};

export const createLogin = async (data: CreateUser) => {
  const { data: response } = await api.post(`/register`, data);
  return response;
};

export const sendContact = async (data: ContactPayload) => {
  const { data: response } = await api.post(`/contact`, data);
  return response;
};